
import React from 'react';
import { Accordion } from '../ui/accordion';
import CertificationCard from './CertificationCard';
import { Certification } from '@/data/certifications';

interface CertificationsListProps {
  certifications: Certification[];
  isVisible: boolean;
}

const CertificationsList: React.FC<CertificationsListProps> = ({ certifications, isVisible }) => {
  return (
    <div className="space-y-4">
      <Accordion type="single" collapsible className="w-full">
        {certifications.map((cert, index) => (
          <CertificationCard 
            key={cert.id}
            certification={cert}
            index={index}
            isVisible={isVisible}
          />
        ))}
      </Accordion>
    </div>
  );
};

export default CertificationsList;
